<template> 
    <div class="seach-view">
        <ul>
            <li v-for="(item,index) in list" :key="index">
                <div class="type-name">{{item.name}}</div>
                <div class="type-val"> 
                    <el-date-picker
                    v-model="item.val"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy/MM/dd"
                    size="small"
                    v-if="item.type===6">
                    </el-date-picker>
                    <input type="text" v-model="item.val" v-else>
                </div>
                <div class="type-fn" @click="activeAdd">
                    <img src="@/assets/search_button_add_up.png" alt="">
                    <img src="@/assets/search_button_add_down.png" alt="">
                </div>
                <!-- <div class="type-fn">
                    <img src="@/assets/search_button_add_up.png" alt="" v-if="index>2" @click="delActive">
                    <img src="@/assets/search_button_add_down.png" alt="" v-if="index>2"  @click="delActive">
                </div> -->

                <div class="yu" v-if="index<(showIndex)">与</div>
            </li>
        </ul>
        <div class="select-btn" @click="seniorSeachActive">
            <img src="@/assets/search_button_search_up.png" alt="">
            <img src="@/assets/search_button_search_down.png" alt="">
        </div>
    </div> 
</template>
<script> 
export default {
  props:{ 
      value:{
          type:String,
          default:""
      }, 
  },
  data() {
    return { 
        showIndex:2,
        dataList:[
            {
                name:"册名",
                val:"", 
                type:2
            },
            {
                name:"篇名",
                val:"", 
                type:3
            },
            {
                name:"注译者",
                val:"",  
                type:4
            },
            {
                name:"出处",
                val:"",  
                type:5
            },
            {
                name:"发表日期",
                val:"",  
                type:6
            },
            {
                name:"类别",
                val:"",  
                type:7
            }
        ]
    }; 
  },
  computed: {
      list:{
          get(){ 
            const newList = this.dataList.filter((item,index)=>{
                return  index <= this.showIndex
            })
            return newList
          }
      }
  }, 
  methods: {
      seniorSeachActive(){
          this.$emit("click",this.dataList)
      },
      activeAdd(){
          if( this.showIndex+1 === this.dataList.length ) return
          this.showIndex++  
      },
    //   delActive(){
    //       this.showIndex-- 
    //       console.log(this.showIndex)
    //   },
      close(){
          this.$emit("close",{})
      },
      change(e) {
        let val = e.target.value;
        this.$emit("input", val);
      },
  },
  mounted() {
  }
};
</script>
<style>
.seach-view .el-date-editor.el-input{
    width: 190px;
}
.seach-view .el-input__inner:focus {
    border-color: #6a6058;
    outline: 0;
}
.seach-view .el-date-table td.today span {
    color: #6a6058!important; 
}

.seach-view .el-date-table td .available:hover {
    color: #6a6058!important;
}

.seach-view .el-date-table td.current:not(.disabled) span { 
    background-color: #6a6058!important;
}
 
</style>
<style scoped lang="less">

.seach-view{

    ul{
        li{
            width: 400px;
            margin: 0 auto;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0 30px 0;
            position: relative;
            // margin-right: 64px;

            &:last-child{
                padding: 0 0 10px 0;
            }

            .yu{
                height: 20px;
                line-height: 20px;
                width: 50px;
                font-size: 14px;
                background-color: #6a6058;
                color: #ede9e2; 
                text-align: center;
                position: absolute;
                bottom: 5px;
                left: 0;
                border-radius: 4px;
            }

            .type-name{
                width: 100px;
                height: 30px;
                line-height: 30px;
                font-size: 16px;
                text-align: center;
                background-size: auto 30px;
                background-image: url(../../assets/main_top_bg_dwon_hg.jpg);
                border-radius: 5px;
                color: #ede9e2;
            }

            .type-val{
                height: 30px;

                input{
                    width: 190px;
                    height: 30px;
                    background-color: rgba(0,0,0,0);
                    box-sizing: border-box;
                    outline: none;
                    border-radius: 5px;
                    padding: 0 5px;
                }
            }

            .type-fn{
                position: relative;
                height: 30px;
                width: 40px;

                img{
                    height: 30px;
                    width: auto;
                    position: absolute;
                    left: 0;
                    top: 0;
                    cursor: pointer;

                    &:nth-child(1){
                        z-index: 3;

                        &:hover{
                            z-index: 1;
                        }
                    }

                    &:nth-child(2){
                        z-index: 2;

                        &:hover{
                            z-index: 4;
                        }
                    }
                }
            }
        }
    }

    .select-btn{
        position: relative;
        height: 28px;

        img{
            height: 28px;
            width: auto;
            position: absolute;
            left: 50%;
            top: 0;
            transform: translateX(-50%);
            cursor: pointer;

            &:nth-child(1){
                z-index: 3;

                &:hover{
                    z-index: 1;
                }
            }

            &:nth-child(2){
                z-index: 2;

                &:hover{
                    z-index: 4;
                }
            }
        }
    }
}
 
</style>
